import { css } from "@emotion/react"
import { useClipboardCopy } from "matsuri-hooks"
import { Button, useAlert, UserTextRenderer, Typography } from "matsuri-ui"
import { useTranslation } from "@/hooks/useTranslation"
import { googleMapSearchUrl, openUrlInNewTab } from "@/utils/urls"

interface Props {
    address: string | undefined
}

export const AddressWithCopy = ({ address }: Props) => {
    const { t } = useTranslation()
    const { addAlert } = useAlert()

    const clipboardCopy = useClipboardCopy({
        onSuccess: () => {
            addAlert(t("住所をコピーしました"), {
                duration: 3000
            })
        }
    })

    return (
        <div
            css={css`
                display: flex;
                gap: 8px;
                align-items: center;
            `}
        >
            <Typography>
                <UserTextRenderer>{address}</UserTextRenderer>
            </Typography>
            <Button
                color="primary"
                variant="outlined"
                size="small"
                onClick={() => {
                    clipboardCopy(address)
                }}
            >
                {t("コピー")}
            </Button>
            <Button
                color="primary"
                variant="outlined"
                size="small"
                disabled={!address}
                onClick={() => {
                    if (address) {
                        openUrlInNewTab(googleMapSearchUrl(address))
                    }
                }}
            >
                {t("Mapで開く")}
            </Button>
        </div>
    )
}
